import axiosClient from '../api/AxiosConfig';

export const AccountService = {
  GetAccounts: async (filter) => {
    return (
      await axiosClient.get('/account', {
        params: filter,
      })
    ).data;
  },
  DisableAccount: async (id) => {
    return (await axiosClient.patch(`/account/${id}/disable`)).data;
  },
  EnableAccount: async (id) => {
    return (await axiosClient.patch(`/account/${id}/enable`)).data;
  },
  DeleteAccount: async (id) => {
    return (await axiosClient.delete(`/account/${id}`)).data;
  },
  GetAccountById: async (id, lang) => {
    return (await axiosClient.get(`/account/${id}`, { params: { lang } })).data;
  },
  EditAccount: async (id, data) => {
    return (await axiosClient.put(`/account/${id}`, data)).data;
  },
  CreateAccount: async (data) => {
    return (await axiosClient.post(`/account`, data)).data;
  },
};
